import { Injectable, Injector } from '@angular/core';
import { IFileClient } from 'app/services/interfaces/IFileClient';

@Injectable()
export abstract class BaseFileClientProviderService<T extends IFileClient> {
    protected readonly className: string = 'BaseFileClientProviderService';
    protected _client: T;

    public get client(): T {
        if (!this._client) {
            this._client = this.getClient();
        }
        return this._client;
    }

    public resetClient(): void {
        this._client = null;
    }

    protected abstract getClient(): T;

    constructor(
        protected readonly _injector: Injector
    ) { }
}
